import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'app/core/services/auth.service';
import { BrandService } from 'app/core/services/brand.service';
import { UserDTO } from 'app/core/dtos/auth.dto';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserMenuComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly brandService = inject(BrandService);

  userMenuItems: MenuItem[] = [];
  userName: string;
  userInitials: string;
  currentUser: UserDTO | null = null;
  brandConfig = this.brandService.config;

  constructor() {
    this.userName = this.brandConfig.defaultUser.name;
    this.userInitials = this.brandConfig.defaultUser.initials;

    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.currentUser = user;
        this.userName = user.fullName;
        this.userInitials = this.brandService.getInitials(user.fullName);
      } else {
        this.userName = this.brandConfig.defaultUser.name;
        this.userInitials = this.brandConfig.defaultUser.initials;
      }
    });
  }

  ngOnInit() {
    this.setupMenuItems();
  }

  private setupMenuItems() {
    this.userMenuItems = [
      {
        label: 'Sair',
        icon: 'logout',
        command: () => {
          this.authService.logout();
        },
      },
    ];
  }
}
